import type { AvatarColorId } from "@/data/avatarCatalog";
import type { CSSProperties } from "react";

export const AVATAR_BACKGROUNDS = [
  { id: "white", name: "White", className: "avatar-bg-white", avatarColor: "black" },
  { id: "lime", name: "Lime", className: "avatar-bg-lime", avatarColor: "green" },
  { id: "yellow", name: "Yellow", className: "avatar-bg-yellow", avatarColor: "yellow" },
  { id: "blue", name: "Blue", className: "avatar-bg-blue", avatarColor: "blue" },
  { id: "pink", name: "Pink", className: "avatar-bg-pink", avatarColor: "pink" },
  { id: "purple", name: "Purple", className: "avatar-bg-purple", avatarColor: "purple" },
  { id: "red", name: "Red", className: "avatar-bg-red", avatarColor: "red" },
  { id: "orange", name: "Orange", className: "avatar-bg-orange", avatarColor: "orange" },
] as const;

export type AvatarBackgroundId = (typeof AVATAR_BACKGROUNDS)[number]["id"];

export const getAvatarBackgroundClass = (background?: string | null): string =>
  background?.startsWith("#") ? "" : AVATAR_BACKGROUNDS.find((option) => option.id === background)?.className ?? "avatar-bg-white";

export const getAvatarBackgroundStyle = (background?: string | null): CSSProperties | undefined =>
  background && /^#[0-9a-f]{6}$/i.test(background) ? { backgroundColor: background } : undefined;

export const getLighterAvatarBackground = (hex: string): string => {
  const value = hex.replace("#", "");
  if (!/^[0-9a-f]{6}$/i.test(value)) return "white";
  const channels = [0, 2, 4].map((offset) => parseInt(value.slice(offset, offset + 2), 16));
  const lighter = channels.map((channel) => Math.round(channel + (255 - channel) * 0.68));
  return `#${lighter.map((channel) => channel.toString(16).padStart(2, "0")).join("")}`.toUpperCase();
};

export const getAvatarColorForBackground = (background?: string | null): AvatarColorId =>
  (AVATAR_BACKGROUNDS.find((option) => option.id === background)?.avatarColor ?? "black") as AvatarColorId;

export const getBackgroundForAvatarColor = (color?: string | null): AvatarBackgroundId =>
  AVATAR_BACKGROUNDS.find((option) => option.avatarColor === color)?.id ?? "white";
